import { useTranslation } from "react-i18next";

const BannerOne = ({setOpenGetDemoModal, setOpenCalendlyModal}) => {
  const { t } = useTranslation();
  
  return (
    <>
      <section className="hero  z-index-1  section-bg ">
        <img src="/assets/images/gradients/banner-gradient-ari-ari.png" alt="" className="bg--gradient"/>
        <div className="container container-three">
          <div className="row align-items-center gy-sm-5 gy-4">
            <div className="col-lg-7">
              <div className="hero-inner position-relative pe-lg-6">
                <div>
                  <h1 className="hero-inner__title">{t("hero.title")}</h1>
                  <p className="hero-inner__desc font-18">{t("hero.desc")}</p>

                  <div className="product-category-list">
                    <button id="get-demo-button" className="btn btn-green btn-md pill btn-banner" onClick={() => setOpenGetDemoModal(true)}>
                      {t("hero.btn.demo")}
                    </button>
                    <button id="consultation-button" onClick={() => setOpenCalendlyModal(true)} className="btn btn-outline-black btn-md pill btn-banner">
                      {t("hero.btn.consultation")}
                    </button>
                  </div>


                  {/* Tech List Start */}
                  {/* <div className="product-category-list">
                    <Link
                      to="/all-product"
                      className="product-category-list__item"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="WordPress"
                    >
                      <img
                        src="/assets/images/thumbs/tech-icon1.png"
                        alt=""
                        className="white-version"
                      />
                      <img
                        src="/assets/images/thumbs/tech-icon-white1.png"
                        alt=""
                        className="dark-version"
                      />
                    </Link>
                    <Link
                      to="/all-product"
                      className="product-category-list__item"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="Laravel"
                    >
                      <img src="/assets/images/thumbs/tech-icon2.png" alt="" />
                    </Link>
                    <Link
                      to="/all-product"
                      className="product-category-list__item"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="PHP"
                    >
                      <img
                        src="/assets/images/thumbs/tech-icon3.png"
                        alt=""
                        className="white-version"
                      />
                      <img
                        src="/assets/images/thumbs/tech-icon-white3.png"
                        alt=""
                        className="dark-version"
                      />
                    </Link>
                    <Link
                      to="/all-product"
                      className="product-category-list__item"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      data-bs-title="HTML"
                    >
                      <img src="/assets/images/thumbs/tech-icon4.png" alt="" />
                    </Link>
                  </div> */}
                  {/* Tech List End */}
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="hero-thumb">
                <img src="/assets/images/thumbs/banner-img-2.webp" alt="ari-ari" />
                
                <div className="statistics  bg-white text-center ">
                  
                  <h5 className="statistics__amount text-heading ">
                    22k
                  </h5>
                  <span className="statistics__text text-heading font-11 font-max-md-9 ">
                    Themes &amp; Plugins
                  </span>
                </div>
                <div className="statistics style-two  text-center">
                  <h5 className="statistics__amount statistics__amount-two text-white ">50k</h5>
                  <span className="statistics__text  font-11 text-white ">
                    Customers
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BannerOne;

